import ShipmentStatus from './ShipmentStatus'

export default ShipmentStatus
